import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getJadwalTcPeserta = 'jadwal-test-center/peserta';
const getJadwalTcPesertaRpl = 'jadwal-test-center/peserta-rpl';
const getDataDokumenRplPeserta = 'jadwal-test-center/dokumen-pendukung-peserta-rpl'
const putDataDokumenRplPeserta = 'sertifikasi-rpl/verifikasi-dokument-peserta-rpl'
const postKehadiran = 'jadwal-test-center/update-kehadiran';
const putKehadiranPesertaRpl = 'jadwal-test-center/update-kehadiran-rpl';
const putJadwalTc = 'jadwal-test-center/';
const deleteJadwalTc = 'jadwal-test-center/';
const getDetailJadwalTc = 'jadwal-test-center/';
const verifikasiDokumenPesertaRpl = 'jadwal-test-center/data-peserta-rpl/verifikasi-dokumen-pendukung';
class MasterJadwalTcService {
    
    getJadwalTcPeserta(idJadwalTc, idSesi) {
        return axios.get(
        API_URL + getJadwalTcPeserta + '?idJadwalTc=' + idJadwalTc + '&idSesi=' + idSesi + '&pageNo=0&pageSize=100000',
        {
            headers: authHeader()
        });
    }

    verifikasiDokumenPesertaRpl(formData) {
        return axios
        .put(
            API_URL + verifikasiDokumenPesertaRpl,
            formData,
            { headers: { 'Content-Type': 'application/json','Authorization' : tokenHeader() } }
        );
    }

    getJadwalTcPesertaRpl(currentPage, pageSize, filter, idJadwalTc, Sesi) {
        return axios.get(
        API_URL + getJadwalTcPesertaRpl + '?pageNo=' + currentPage + '&pageSize=' + pageSize + '&filter=' + filter+ '&idJadwalTc=' + idJadwalTc + '&sesi=' + Sesi,
        {
            headers: authHeader()
        });
    }

    getDataDokumenRplPeserta(idSertifikasiRplPeserta){
        return axios.get(
            API_URL + getDataDokumenRplPeserta + '?idSertifikasiRplPeserta=' + idSertifikasiRplPeserta,
            {
                headers: authHeader()
            }
        );
    }

    postKehadiran(formData) {        
        return axios
        .post(
            API_URL + postKehadiran,
            formData,
            { headers: authHeader() }
        );
    }

    putKehadiranPesertaRpl(formData) {        
        return axios
        .put(
            API_URL + putKehadiranPesertaRpl,
            formData,
            { headers: authHeader() }
        );
    }

    putDataDokumenRplPeserta(id_dokumen_pendukung_rpl){
        return axios.put(
            API_URL + putDataDokumenRplPeserta + '?id_dokumen_pendukung_rpl=' + id_dokumen_pendukung_rpl,
            {
                headers: authHeader()
            }
        );
    }

    putJadwalTc(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putJadwalTc + formData.idJadwalTc, formData,
            { headers: authHeader() }
        );
    }

    deleteJadwalTc(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteJadwalTc + formData.idJadwalTc,
                { headers: authHeader() }
            );
    }

    getDetailJadwalTc(idJadwalTc) {
        var headers = authHeader();

        return axios
        .get(
            API_URL + getDetailJadwalTc + idJadwalTc,
            { headers: authHeader() }
        );
    }

}

export default new MasterJadwalTcService();
